export default{
    methods: {
        extraLabel(form, field){
            let label = "";
            if(!_.isNil(field) && !_.isEmpty(field)){
                label = `-${field}`;
            }else if(!_.isNil(form) && form === "company"){
                label = `-${form}`;
            }
            return label;
        },
        getDatabot(key, formName, field = null, element = "form"){
            let form = "";
            if (formName && formName !== ""){
                form = formName.slice(0, formName.indexOf("Form"));
            }
            let target = "";
            if(!_.isEmpty(key)) {
                target = `--${key}`;
            }

            return (!_.isEmpty(form)) ? `${form}-overview__${element}${this.extraLabel(form, field)}${target}` : "";
        }
        
    }
}